<template>
  <el-dialog
  :title="popTitle"
  :visible.sync="visibleDialog"
  width="424px"
  :top="popTop"
  class="pop-dialog pop-set-remark"
  append-to-body>
  <div v-if="type === 'remark'" class="remak-con">
    <el-input
      type="textarea"
      :rows="3"
      maxlength="64"
      placeholder="请输入备注信息…"
      v-model="textarea">
    </el-input>
  </div>
  <div v-else-if="type === 'afterSale'" class="remak-con">
    <div class="item-remark" v-for="(item,index) of saleList" :key="index">
      <div class="item-title">售后单{{ item.afterSalesNo }}</div>
      <div class="item-con">
        <div class="item-label">备注</div>
        <el-input
          class="item-input"
          type="textarea"
          :rows="3"
          maxlength="64"
          placeholder="请输入备注信息…"
          v-model="item.remark">
        </el-input>
      </div>
    </div>
  </div>
  <template slot="footer">
    <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="onConfirm" size="mini" :loading="loading">确 定</el-button>
  </template>
</el-dialog>
</template>
<script>
  export default {
    name:'popSetRemark',
    data () {
      return {
        visibleDialog:false,
        loading:false,
        textarea:'',
        id:'',
        popTitle:'客服备注',
        type:'',
        popTop:'',
        saleList:[
          {
            afterSalesNo:'',
            remark:''
          }
        ],
      }
    },

    methods: {
       // 批量设置不需要回显
      show(item,type) {
        console.log('show：',item,type)
        this.id = item.id
        this.textarea = item.serviceRemark
        this.type = type
        if (this.type=='afterSale') {
          this.popTitle = '售后备注'
          this.saleList = JSON.parse(JSON.stringify(item.afterSalesInfoList))
          let saleCount = this.saleList.length
          if (saleCount<7) {
            this.popTop = `calc(50vh - ${65+saleCount*55}px)`
          }else{
            this.popTop = '0'
          }
          console.log('>>',this.popTop)
        }else{
          this.popTitle = '客服备注'
          this.textarea = item.serviceRemark
          // 只有一个
          this.popTop = 'calc(50vh - 120px)'
        }
        this.visibleDialog = true
      },
      // 确认修改
      onConfirm() {
          let data
          let  APIURL
          if (this.type=='afterSale') {
            let list = []
            this.saleList.forEach(e => {
              list.push(
                {
                  afterSalesNo:e.afterSalesNo,
                  remark:e.remark
                }
              )
            })
            data = {
              afterSalesRemarkList:list
            }
            APIURL = 'omsOrderRemarkSale'
          }else{
            data = {
              orderId:this.id,
              serviceRemark:this.textarea
            }
            APIURL = 'omsOrderRemark'
          }
          this.loading = true
          console.log('>>',data)
          // return
          this.$api[APIURL](data).then((res) => {
            if (res.code === 0) {
              this.$message.success('修改成功')
              this.$emit('fetchData')
            }
          }).finally(() => {
            this.loading = false
            this.visibleDialog = false
          })
        }
      },
  }
</script>
<style lang='scss'>
.pop-set-remark{
  .remak-con{
    padding: 20px 0 0 0;
    .el-textarea__inner{
      padding-left: 8px;
      font-size: 12px;
      height: 66px;
    }
    .item-remark + .item-remark{
      margin-top: 20px;
    }
    .item-remark{
      .item-title{
        margin-bottom: 6px;
      }
      .item-con{
        display: flex;
         .item-label{
          width: 40px;
        }
      }
    }
  }
}
</style>